import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "mb-2" }
const _hoisted_2 = { class: "col post-filter" }
const _hoisted_3 = { class: "btn-list" }
const _hoisted_4 = ["onClick"]


  
export default /*#__PURE__*/_defineComponent({
  __name: 'PostFilter',
  props: {
    categories: Array,
    currentCategory: Number
  },
  emits: ['categoryChanged'],
  setup(__props, { emit }) {

const props = __props;



  

  const getClass = (categoryId: number|null) => {
    return (categoryId === props.currentCategory) ? 'button button--narrow mr-2 mb-2' : 'button button--narrow button--subtle mr-2 mb-2';
  }

  const updateCategory = (categoryId: number) => {
    emit('categoryChanged', categoryId === 0 ? null : categoryId);
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: _normalizeClass(getClass(null)),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (updateCategory(0)))
        }, "All Categories", 2),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.categories, (category) => {
          return (_openBlock(), _createElementBlock("button", {
            class: _normalizeClass(getClass(category.id)),
            key: category.slug,
            onClick: ($event: any) => (updateCategory(category.id))
          }, _toDisplayString(category.name), 11, _hoisted_4))
        }), 128))
      ])
    ])
  ]))
}
}

})